import { render, staticRenderFns } from "./LayoutBackgroundChanger.vue?vue&type=template&id=5bfeeadc&scoped=true&"
import script from "./LayoutBackgroundChanger.vue?vue&type=script&lang=js&"
export * from "./LayoutBackgroundChanger.vue?vue&type=script&lang=js&"
import style0 from "./LayoutBackgroundChanger.vue?vue&type=style&index=0&id=5bfeeadc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfeeadc",
  null
  
)

export default component.exports